import BaseDeliveryRoute from 'cio/routes/base-delivery';
import { isEmpty } from '@ember/utils';

export default class DeliveryRoute extends BaseDeliveryRoute {
  crumb() {
    let model = this.modelFor(this.routeName);

    return {
      name: isEmpty(model.get('detail.subject')) ? model.subject : model.get('detail.subject'),
      path: 'outbox.deliveries.delivery',
      model,
    };
  }
}
